import { generateEnumByScreenSize, addTailwindModifier } from '@/utils/tailwind-util';

export const MarginEnum = Object.freeze({
	MARGIN_TOP_12: 'mt-3',
	MARGIN_TOP_24: 'mt-6',
	MARGIN_TOP_40: 'mt-10',
	MARGIN_TOP_80: 'mt-20',
	MARGIN_RIGHT_12: 'mr-3',
	MARGIN_RIGHT_24: 'mr-6',
	MARGIN_RIGHT_40: 'mr-10',
	MARGIN_RIGHT_80: 'mr-20',
	MARGIN_BOTTOM_12: 'mb-3',
	MARGIN_BOTTOM_24: 'mb-6',
	MARGIN_BOTTOM_40: 'mb-10',
	MARGIN_BOTTOM_80: 'mb-20',
	MARGIN_LEFT_12: 'ml-3',
	MARGIN_LEFT_24: 'ml-6',
	MARGIN_LEFT_40: 'ml-10',
	MARGIN_LEFT_80: 'ml-20',
});

export const PaddingEnum = Object.freeze({
	PADDING_Y_16: 'py-4',
	PADDING_Y_24: 'py-6',
	PADDING_Y_32: 'py-8',
	PADDING_X_16: 'px-4',
	PADDING_X_24: 'px-6',
	PADDING_X_32: 'px-8',
});

export const ButtonEnum = Object.freeze({
	PRIMARY: 'bg-mariner text-white hover:bg-mariner-light active:bg-mariner-dark shadow-button no-underline',
	SECONDARY: 'bg-solitude text-white hover:bg-aqua-haze active:bg-ghost shadow-button no-underline',
	CALL_TO_ACTION: 'bg-tree-poppy text-white hover:bg-tree-poppy-light active:bg-tree-poppy-dark shadow-button',
	SECONDARY_MARINER:
		'text-mariner border border-mariner hover:text-mariner-light hover:bg-mariner-light hover:bg-opacity-12 active:bg-mariner-dark active:bg-opacity-24 active:text-mariner-dark',
	SECONDARY_TREE_POPPY:
		'text-tree-poppy border border-tree-poppy hover:text-tree-poppy-light hover:bg-tree-poppy-light hover:bg-opacity-12 active:bg-tree-poppy-dark active:bg-opacity-24 active:text-tree-poppy-dark',
	SECONDARY_WHITE:
		'text-white border border-white hover:bg-white hover:bg-opacity-12 active:bg-white active:bg-opacity-24 focus:outline-none focus:ring focus:ring-white focus:ring-opacity-30',
	SHARED_CLASSES:
		'min-w-44 3xl:min-w-54 3xl:text-xl 3xl:py-3 px-6 py-2 whitespace-nowrap box-border align-baseline font-sans font-semibold text-center rounded active:text-opacity-70 disabled:opacity-50 focus:outline-none focus:ring focus:ring-mariner focus:ring-opacity-30 hover:duration-150',
});

export const AlignmentEnum = Object.freeze({
	FLEX_JUSTIFY_START: 'justify-start',
	FLEX_JUSTIFY_CENTER: 'justify-center',
	FLEX_JUSTIFY_END: 'justify-end',
	FLEX_JUSTIFY_STRETCH: 'justify-stretch',
	FLEX_ITEMS_START: 'items-start',
	FLEX_ITEMS_CENTER: 'items-center',
	FLEX_ITEMS_END: 'items-end',
	FLEX_ITEMS_STRETCH: 'items-stretch',
	FLEX_ALIGN_SELF_START: 'self-start',
	FLEX_ALIGN_SELF_CENTER: 'self-center',
	FLEX_ALIGN_SELF_END: 'self-end',
	FLEX_ALIGN_SELF_STRETCH: 'self-stretch',
});

export const FlexDirectionEnum = Object.freeze({
	FLEX_DIRECTION_ROW: 'flex-row',
	FLEX_DIRECTION_ROW_REVERSE: 'flex-row-reverse',
	FLEX_DIRECTION_TABLET_ROW: 'sm:flex-row',
	FLEX_DIRECTION_COLUMN: 'flex-col',
	FLEX_DIRECTION_TABLET_COLUMN: 'flex-col lg:flex-row',
	FLEX_DIRECTION_COLUMN_REVERSE: 'flex-col-reverse',
});

export const TextAlignEnum = Object.freeze({
	TEXT_ALIGN_LEFT: 'text-left',
	TEXT_ALIGN_CENTER: 'text-center',
	TEXT_ALIGN_RIGHT: 'text-right',
});

export const TextColorEnum = Object.freeze({
	FONT_WHITE: 'prose-white',
	FONT_MIDNIGHT: 'prose-midnight',
	FONT_POSITIVE: 'prose-positive',
	FONT_PUMPKIN: 'prose-pumpkin',
});

export const VisibilityEnum = Object.freeze({
	HIDE_ON_DESKTOP: 'lg:hidden',
	HIDE_ON_TABLET: 'flex md:hidden lg:flex',
	HIDE_ON_MOBILE: 'hidden sm:flex',
});

export const GridColumnSizes = Object.freeze({
	GRID_COLUMN_TABLET_ONE_THIRD: 'md:col-span-2',
	GRID_COLUMN_TABLET_HALF: 'md:col-span-3',
	GRID_COLUMN_TABLET_TWO_THIRD: 'md:col-span-4',
	GRID_COLUMN_TABLET_FULL: 'md:col-span-6',
	GRID_COLUMN_DESKTOP_ONE_THIRD: 'lg:col-span-2',
	GRID_COLUMN_DESKTOP_HALF: 'lg:col-span-3',
	GRID_COLUMN_DESKTOP_TWO_THIRD: 'lg:col-span-4',
	GRID_COLUMN_DESKTOP_FULL: 'lg:col-span-6',
	GRID_COLUMN_DESKTOP_CENTER_ONE_THIRD: 'lg:col-start-3 lg:col-span-2',
	GRID_COLUMN_DESKTOP_CENTER_HALF: 'lg:col-start-2 lg:col-span-4',
});

export const IconSizesEnum = Object.freeze({
	ICON_SIZE_SMALL: 'w-22 h-22 sm:h-26 sm:w-26 xl:w-30 xl:h-30 2xl:h-34 2xl:w-34 3xl:w-38 3xl:h-38',
	ICON_SIZE_LARGE: 'w-30 h-30 sm:h-40 sm:w-40 xl:w-50 xl:h-50 2xl:w-55 2xl:h-55 3xl:w-60 3xl:h-60',
});

export const ColumnGapEnum = Object.freeze({
	COLUMN_GAP_X_40: 'gap-x-10 gap-y-10 sm:gap-y-20',
	COLUMN_GAP_X_20: 'gap-x-5 gap-y-10',
});

export const ColumnWidthEnum = Object.freeze({
	COLUMN_WIDTH_ONE_THIRD: 'w-1/3',
	COLUMN_WIDTH_HALF: 'w-1/2',
	COLUMN_WIDTH_TWO_THIRD: 'w-2/3',
	COLUMN_WIDTH_FULL: 'w-full',
});

export const ColumnOrderEnum = Object.freeze({
	ORDER_1: 'order-1 lg:order-none',
	ORDER_2: 'order-2 lg:order-none',
	ORDER_3: 'order-3 lg:order-none',
	ORDER_4: 'order-4 lg:order-none',
	ORDER_5: 'order-5 lg:order-none',
	ORDER_6: 'order-6 lg:order-none',
});

export const BackgroundColorEnum = Object.freeze({
	TREE_POPPY: 'bg-tree-poppy',
	MARINER: 'bg-mariner',
	SOLITUDE: 'bg-solitude',
	MARINER_EXTRA_LIGHT: 'bg-mariner-extra-light',
	WHITE: 'bg-white',
	HEATHER: 'bg-heather',
	SHUTTLE_GREY: 'bg-shuttle-grey',
	SKY_LIGHTEST: 'bg-sky-lightest',
});

export const BackgroundHoverColorEnum = Object.freeze({
	HOVER_MARINER_EXTRA_LIGHT: 'hover:bg-mariner-extra-light',
});

export const BackgroundActiveColorEnum = Object.freeze({
	ACTIVE_SKY_LIGHT: 'active:bg-sky-light',
});

export const BorderColorEnum = Object.freeze({
	WHITE: 'border-white',
	HEATHER: 'border-heather',
	SHUTTLE_GREY: 'border-shuttle-grey',
	MARINER_EXTRA_LIGHT: 'border-mariner-extra-light',
});

export const FillColorEnum = Object.freeze({
	TREE_POPPY: 'fill-tree-poppy',
	MARINER: 'fill-mariner',
	SOLITUDE: 'fill-solitude',
	MARINER_EXTRA_LIGHT: 'fill-mariner-extra-light',
	WHITE: 'fill-white',
	SKY_LIGHTEST: 'fill-sky-lightest',
});

export const ScreenSizeEnum = Object.freeze({
	MOBILE: '',
	TABLET: 'md:',
	DESKTOP: 'lg:',
});

export const BorderRadiusEnum = Object.freeze({
	BORDER_RADIUS_LG: 'rounded-lg',
	BORDER_RADIUS_LG_TOP_LEFT: 'rounded-tl-lg',
	BORDER_RADIUS_LG_TOP_RIGHT: 'rounded-tr-lg',
	BORDER_RADIUS_LG_BOTTOM_RIGHT: 'rounded-br-lg',
	BORDER_RADIUS_LG_BOTTOM_LEFT: 'rounded-bl-lg',
});

export const HeadingAlignEnum = addTailwindModifier('prose-headings:', TextAlignEnum);

export const ProseHeadingEnum = generateEnumByScreenSize(
	{ MOBILE: ScreenSizeEnum.MOBILE, TABLET: ScreenSizeEnum.TABLET },
	HeadingAlignEnum
);

export const TextEnum = generateEnumByScreenSize(
	{ MOBILE: ScreenSizeEnum.MOBILE, TABLET: ScreenSizeEnum.TABLET },
	TextAlignEnum
);

export const ContentContainerEnum = Object.freeze({
	...AlignmentEnum,
	...FlexDirectionEnum,
	...MarginEnum,
	...VisibilityEnum,
	...PaddingEnum,
	...BackgroundColorEnum,
	...BackgroundHoverColorEnum,
	...BackgroundActiveColorEnum,
	...BorderRadiusEnum,
});

export const mapKeysToValues = enums => {
	const mappedEnums = {};

	for (const key in enums) {
		if (Object.prototype.hasOwnProperty.call(enums, key)) {
			mappedEnums[key] = {};
			for (const innerKey in enums[key]) {
				if (Object.prototype.hasOwnProperty.call(enums[key], innerKey)) {
					mappedEnums[key][innerKey] = innerKey;
				}
			}
		}
	}

	return mappedEnums;
};

/**
 * Used for mapping all styling enums values to their key so they can be used as enum values
 *
 * Example:
 * const { ButtonEnum } = StylingEnums;
 * <Button buttonType={ButtonEnum.SECONDARY_TREE_POPPY} .... />
 */
export const StylingEnums = mapKeysToValues({
	AlignmentEnum,
	FlexDirectionEnum,
	MarginEnum,
	VisibilityEnum,
	PaddingEnum,
	BackgroundColorEnum,
	BackgroundHoverColorEnum,
	BackgroundActiveColorEnum,
	BorderRadiusEnum,
	ContentContainerEnum,
	ButtonEnum,
	TextAlignEnum,
	TextColorEnum,
	GridColumnSizes,
	IconSizesEnum,
	ColumnGapEnum,
	ColumnWidthEnum,
	ColumnOrderEnum,
	FillColorEnum,
	ScreenSizeEnum,
	ProseHeadingEnum,
	TextEnum,
});
